import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Query } from '../op-types';

export function createExchangeRateQueries(client: StoxlyClient) {
  return createQueryKeys('exchangeRates', {
    // ['exchangeRates', 'latestRates', { query }]
    latestRates: (query?: Query<'exchangeRatesGetLatestRates'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.exchangeRatesGetLatestRates({ queries: query, signal }),
    }),

    // ['exchangeRates', 'historicalRates', { query }]
    historicalRates: (query: Query<'exchangeRatesGetHistoricalRates'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.exchangeRatesGetHistoricalRates({ queries: query, signal }),
    }),

    // ['exchangeRates', 'dailySeries', { query }] — the business-day rate series
    // for one pair over a range (gap-filled + persisted server-side).
    dailySeries: (query: Query<'exchangeRatesGetDailyRateSeries'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.exchangeRatesGetDailyRateSeries({ queries: query, signal }),
    }),
  });
}
